module.exports = __webpack_public_path__ + "static/img/MRI_1.b2599777.jpg";